import logo from "../../assets/images/anjas-white.png";

const Footer = () => {
  return (
    <footer className="max-w-full mt-0 px-4 py-10 bg-stone-900">
      <div
        className="container mx-auto md:flex  font-poppins"
        data-aos="fade-up"
        data-aos-duration="800"
      >
        <div className="w-full flex md:w-2/6">
          <img src={logo} alt="" className="w-60 h-60 mx-auto" />
        </div>
        <div className="mx-14 mt-8 md:hidden">
          <h3 className="text-lg text-slate-50 font-medium">Layanan Kami</h3>
          <ul className="list-disc list-inside text-slate-100 text-sm font-light mt-2">
            <li>Elegan</li>
            <li>Modern</li>
            <li>Garansi</li>
            <li>Kualitas Terbaik</li>
            <li>Terpercaya</li>
          </ul>
        </div>
        <div className="mx-14 mt-8 md:w-2/6">
          <h3 className="text-lg md:text-2xl text-slate-50 font-medium">
            Produk
          </h3>
          <ul className="list-disc list-inside text-slate-100 text-sm md:text-base font-light mt-2">
            <li className="font-light">Tas</li>
            <li>Kaos</li>
            <li>Kemeja</li>
            <li>Jaket</li>
            <li>Seragam</li>
            <li>Sweater</li>
          </ul>
        </div>
        <div className="mx-14 mt-8 md:w-2/6">
          <h3 className="text-lg text-slate-50 font-medium md:text-2xl">
            Hubungi Kami
          </h3>
          <ul className=" text-slate-100 text-sm font-light mt-2">
            <li className="text-[12px] md:text-base leading-none ">
              Jln.Sultang Agung Kp.Rawapasung 004/022 No.20 Kel.Kota Baru
              Kec.Bekasi Barat
            </li>
            <li className="text-[12px] mt-2 md:text-base">
              Telepon : 083808240280
            </li>
            <li className="text-[12px] mt-2 md:text-base">
              Email : anjasgroup.ind@gmail.com
            </li>
          </ul>
        </div>
        <div className="mx-14 md:w-2/6 hidden md:block md:mt-8">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.37217787889!2d106.97299447377989!3d-6.2145498608677645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698d27f5f36e3d%3A0xe5c371aeeb6306eb!2sAnjas%20Konveksi!5e0!3m2!1sid!2sid!4v1686498267695!5m2!1sid!2sid"
            width="300"
            height="250"
            className="border-none"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
